import React from "react";
import LegalLayout from "../../components/portal/LegalLayout";

export default function AccessibilityPage() {
  return (
    <LegalLayout title="Accessibility Statement">
      <p>
        At <strong>Antarctic Press</strong>, we are committed to ensuring digital accessibility for everyone,
        including individuals with disabilities. We strive to continually improve the user experience
        for all users and apply the relevant accessibility standards wherever possible.
      </p>

      <h2>Measures to Support Accessibility</h2>
      <ul>
        <li>Integrates accessibility into our development practices</li>
        <li>Regularly tests our platform using accessibility tools and screen readers</li>
        <li>Provides training for our developers and content managers on accessibility best practices</li>
        <li>Welcomes feedback from users on accessibility issues</li>
      </ul>

      <h2>Conformance Status</h2>
      <p>
        Antarctic Press aims to conform with the <strong>Web Content Accessibility Guidelines (WCAG) 2.1</strong>, Level AA.
      </p>

      <h2>Known Limitations</h2>
      <p>
        While we strive to make all areas of the site fully accessible, there may be some content or
        features that are not yet fully optimized. These include:
      </p>
      <ul>
        <li>Some third-party components or integrations</li>
        <li>Visual content lacking alternative text</li>
        <li>Minor inconsistencies in keyboard navigation in legacy browsers</li>
      </ul>

      <h2>Feedback and Support</h2>
      <p>
        We welcome your feedback on the accessibility of Antarctic Press. If you encounter any barriers or
        have suggestions, please contact us:
      </p>
      <ul>
        <li>Email: <a href="mailto:support@antarcticpress.com">support@antarcticpress.com</a></li>
        <li>Subject: Accessibility Feedback</li>
        <li>We aim to respond to accessibility concerns within 5 business days.</li>
      </ul>

      <h2>Compatibility</h2>
      <p>This platform is compatible with:</p>
      <ul>
        <li>NVDA and VoiceOver screen readers</li>
        <li>Keyboard-only navigation</li>
        <li>Chrome, Firefox, Safari, and Edge</li>
      </ul>

      <h2>Assessment Approach</h2>
      <p>
        We assess accessibility through automated tools, manual testing, and feedback from real users.
      </p>

      <p>Thank you for using Antarctic Press. Your experience matters to us.</p>
    </LegalLayout>
  );
}
